import { StyleSheet } from 'react-native';

import maxContainerWidthStyle from '../../styles/max-container-width/max-container-width.style';
import {
  extraSmallPaddingVerticalBox,
  mediumPaddingHorizontalBox,
} from '../view-style';

export default StyleSheet.create({
  container: {
    flex: 1,
    columnGap: 12,
    justifyContent: 'flex-start',
    borderRadius: 6,
    ...extraSmallPaddingVerticalBox,
    ...mediumPaddingHorizontalBox,
    ...maxContainerWidthStyle,
  },
  button: {
    flex: 1,
  },
});
